export default {
  methods: {
    dateFilter(str, type, noYear) {
      if (str) {
        let date = str.substr(0, 10)
        if (type) {
          if (noYear) {
            let arr = []
            let splitArr = date.split('-')
            arr.push(splitArr[1])
            arr.push(splitArr[2])
            date = arr.join(type)
          } else {
            date = date.split('-').join(type)
          }
        }
        return date
      }
    }
  }
}
